export default "__VITE_ASSET__D0dDLe0R__"